import HealthDataFilterForm, {
	HealthDataFilterFormValues,
} from './HealthDataFilterForm';
import useHealthDataSource from '../../Hooks/useHealthDataSource';
import { HealthData } from '../../Enums/HealthData.enum';
import { HealthDataType } from '../../Enums/HealthDataType.enum';
import { diabetesHealthDataFilterScheme } from './DiabetesHealthDataFilterScheme';
import { getOneWeekBeforeDate } from '../../../../Utils/dates.util';
import { useEffect } from 'react';
import moment, { isMoment } from 'moment';
import useHealthDataFilter from '../../Hooks/useHealthDataFilter';

interface DiabetesHealthDataFilterFormProps {
	onSubmit: (values: HealthDataFilterFormValues) => void;
}

const defaultValues = {
	rom: getOneWeekBeforeDate(new Date()),
	to: new Date(),
	date: new Date(),
	view: 'day',
	dataType: HealthDataType.DEFAULT,
	toggleBloodGlucose: true,
	glucoseView: 'allValues',
	toggleBloodPressure: true,
	toggleWeight: true,
	toggleWaistline: true,
	source: {
		appleHealth: false,
		googleFit: false,
		questionnaire: true,
		ingestion: true,
	},
};

const DiabetesHealthDataFilterForm: React.FC<
	DiabetesHealthDataFilterFormProps
> = props => {
	const { onSubmit } = props;
	const { mapSources } = useHealthDataSource();
	const { getPrepareFilterData } = useHealthDataFilter();

	useEffect(() => {
		handleOnSubmit(defaultValues);
	}, []);

	const handleOnSubmit = (values: any) => {
		const keys: string[] = [];
		if (values.toggleBloodPressure) {
			keys.push(
				HealthData.BLOOD_PRESSURE_SYSTOLIC,
				HealthData.BLOOD_PRESSURE_DIASTOLIC,
				HealthData.HEARTH_RATE,
			);
		}
		if (values.toggleWeight) {
			keys.push(HealthData.WEIGHT);
		}
		if (values.toggleWaistline) {
			keys.push(HealthData.WAISTLINE);
		}
		if (values.toggleBloodGlucose) {
			if (values.glucoseView === 'individualValues') {
				if (values.blood_glucose) {
					Object.keys(values.blood_glucose).map((item, index) => {
						if (values.blood_glucose[item]) {
							keys.push(item);
						}
					});
				}
			} else {
				keys.push(HealthData.BLOOD_GLUCOSE);
			}
		}

		const dataForFilter = getPrepareFilterData(
			values.view,
			values.date,
			values.from,
			values.to,
		);

		const filterValues: HealthDataFilterFormValues = {
			from: dataForFilter.from,
			to: dataForFilter.to,
			view: dataForFilter.view,
			source: mapSources(values.source),
			type:
				dataForFilter.view === 'day' ? values.dataType : HealthDataType.DEFAULT,
			keys: keys,
		};

		onSubmit(filterValues);
	};

	return (
		<HealthDataFilterForm
			onSubmit={handleOnSubmit}
			formScheme={diabetesHealthDataFilterScheme}
			defaultValues={defaultValues}
			submitText='base.shared.filtering'
		/>
	);
};

export default DiabetesHealthDataFilterForm;
